import request from '@/utils/request'
import locale from './../lang/i18n'
import { adminPath, deleteMedia, paged, updateSettings, uploadMedia } from './adminV1'

function publicLocale () {
  return locale.locale === 'en-US' ? 'en' : 'zh-cn'
}

function payload (data) {
  return {
    title: data.title,
    content: data.content,
    publishDate: data.publishDate,
    coverUrl: data.addCoverUrl || data.coverUrl || '',
    slug: data.slug,
    translationGroup: data.translationGroup,
    seoTitle: data.seoTitle,
    metaDescription: data.metaDescription,
    coverAlt: data.coverAlt || data.title,
    publishStatus: data.publishStatus || 'PUBLISHED'
  }
}

export function addNews (data) {
  return request({ url: adminPath('/news'), method: 'post', data: payload(data) })
    .then(result => ({ code: 0, data: result }))
}

export function updateNews (data) {
  const id = data.id || data.newsId
  return request({ url: adminPath(`/news/${id}`), method: 'put', data: payload(data) })
    .then(result => ({ code: 0, data: result }))
}

export function deleteNews (id) {
  return request({ url: adminPath(`/news/${id}`), method: 'delete' })
    .then(() => ({ code: 0 }))
}

export function getNewsList (data) {
  const query = data || {}
  return request({ url: `/api/public/v1/${publicLocale()}/news`, method: 'get' }).then(list => {
    const page = paged(list, query)
    return {
      code: 0,
      data: {
        data: page.rows.map(item => ({ ...item, id: item.slug, author: '智会云科技' })),
        total: page.total
      }
    }
  })
}

export function getAdminNewsList (data) {
  const query = data || {}
  return request({
    url: adminPath('/news/page'),
    method: 'get',
    params: {
      pageNum: query.pageNum,
      pageSize: query.pageSize,
      searchTitle: String(query.searchTitle || '').trim() || undefined
    }
  }).then(page => ({ code: 0, data: { data: page.rows, total: page.total } }))
}

export function getContent (slug) {
  return request({
    url: `/api/public/v1/${publicLocale()}/news/${encodeURIComponent(slug)}`,
    method: 'get'
  }).then(data => ({ code: 0, data: { news: { title: data.title, content: data.content } } }))
}

export function getAdminNewsById (id) {
  return request({ url: adminPath(`/news/${id}`), method: 'get' })
    .then(data => ({ code: 0, data: { news: data } }))
}

export function uploadImage (file, kind = 'image') {
  return uploadMedia(file, kind).then(data => ({ code: 0, data }))
}

export function uploadCover (file) {
  return uploadMedia(file, 'image').then(data => ({ code: 0, data: data.url }))
}

export function delCover (newsId, url) {
  return deleteMedia(url).then(() => ({ code: 0 }))
}

export function settingTopBackground (file) {
  return uploadMedia(file, 'image')
    .then(media => updateSettings({ newsTopImage: media.url }))
    .then(data => ({ code: 0, data }))
}

export function getTopBackground () {
  return request({ url: adminPath('/settings'), method: 'get' })
    .then(data => ({ code: 0, data: { value: data.newsTopImage || '' } }))
}

export function getWebTopBackground () {
  return request({ url: `/api/public/v1/${publicLocale()}/media/NEWS_TOP_IMG`, method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function updateNewsIntroImg (file) {
  return uploadMedia(file, 'image')
    .then(media => updateSettings({ homeNewsImage: media.url }))
    .then(data => ({ code: 0, data }))
}

export function getNewsIntroImg () {
  return request({ url: adminPath('/settings'), method: 'get' })
    .then(data => ({ code: 0, data: { value: data.homeNewsImage || '' } }))
}

export function getNewsListAll () {
  return request({ url: `/api/public/v1/${publicLocale()}/news`, method: 'get' })
    .then(list => ({ code: 0, data: (list || []).map(item => ({ ...item, id: item.slug })) }))
}
